
<p-chart type="doughnut" [data]="dataSet" [options]="options" [height]="height"></p-chart>

<div class="flex justify-content-center mt-4 ">
    <div class="label-value text-center" *ngFor="let label of labels ; let index = index">
        <div [style.color]="colors[index]">
            {{ data[index] }} %
            <span class="label-description block nowrap">{{label}}</span>
        </div>
    </div>
</div>